import { render, staticRenderFns } from "./dlg_accountInactive.vue?vue&type=template&id=38adbcf0"
import script from "./dlg_accountInactive.vue?vue&type=script&lang=js"
export * from "./dlg_accountInactive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports